<div class="col-10 col-md-7 col-xl-6 mx-auto mt-5 mb-3 stepper">
    <div class="d-flex stepper-line stepper-line-1">
        <ng-container *ngFor="let item of totalStep; let i = index; let last = last">
            <ng-container *ngIf = "recipientModel.currentStep <= i + 1">
                <div class="circle" [ngClass]="{
                    'circle-heather': recipientModel.currentStep < i + 1
                }"></div>
            </ng-container>
       
            <ng-container *ngIf = "recipientModel.currentStep > i + 1">
                <div class="circle circle-complete">
                    <img class="icon-info ml-auto" src="./assets/images/icon-png/tick.svg" alt="" />
                </div>
            </ng-container>
            <div class="line" [class.change-width]= "totalStep.length === 4" *ngIf="!last"></div>
        </ng-container>
    </div>
    <div class="row stepper-line">
        <ng-container *ngFor="let item of totalStep; let i = index">
            <span class="text" [ngClass]="{
                'text-heather': recipientModel.currentStep < i + 1
            }">{{item}}</span>
        </ng-container>
    </div>
</div>
